
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rejoindre",
      function () {
        return require("private-next-pages/rejoindre.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rejoindre"])
      });
    }
  